import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '@': 'editingProposal',
  },
  subqueries: {
    editingProposal: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'proposalId',
          },
        ],
      },
      target: 'ent:!proposals:!proposal',
      quantity: 1,
      selection: {
        '{}': {
          name: 'Proposal Details',
          type: 'details',
          watch: {
            '[]': [
              {
                '{}': {
                  alias: 'save.proposal',
                },
              },
            ],
          },
          content: {
            '{}': {
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!proposals#!proposal:!code',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'id',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId: 'attr:ent#!proposals#!proposal:!id',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!id',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!proposals#!proposal:!name',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'status',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!proposals#!proposal:!status',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!status',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'amount',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!proposals#!proposal:!amount',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!amount',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'dueDate',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!proposals#!proposal:!due_date',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!due_date',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'client',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!proposals#!proposal:!client',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': [
                          '!client',
                          {
                            ref: {
                              format: 'ent',
                              entityIdFormat: 'full',
                            },
                          },
                        ],
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'orgOffering',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId:
                                'attr:ent#!proposals#!proposal:!org_offering',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': [
                          '!org_offering',
                          {
                            ref: {
                              format: 'ent',
                              entityIdFormat: 'full',
                            },
                          },
                        ],
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'organization',
                      meta: {
                        '{}': {
                          dmsAttr: {
                            '{}': {
                              attributeId: 'attr:ent#!proposals#!proposal:!org',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              format: 'ent',
                              entityIdFormat: 'full',
                            },
                          },
                        ],
                      },
                    },
                  },
                ],
              },
              onSave: {
                '{}': {
                  action: {
                    '{}': {
                      alias: 'save.proposal',
                    },
                  },
                  variables: {
                    '{}': {
                      proposalId: {
                        '@$': 'proposalId',
                      },
                      proposalCode: '${field:code}',
                      proposalName: '${field:name}',
                      proposalAmount: '${field:amount}',
                      proposalClient: '${field:client}',
                      proposalStatus: '${field:status}',
                      proposalDueDate: '${field:dueDate}',
                      proposalOrgOffering: '${field:orgOffering}',
                      proposalOrganization: '${field:organization}',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
